/*
Rajesh 11/14/2022 2699292412 Add night jobs New UX.
Rajesh 11/15/2022 2699292412 Added Add Task stepper component.
Rajesh 11/15/2022 2699292412 Added Buttons and props.
*/
/*
SaiKrishna 10/06/2022 3225736869 Removed unnecessary console.log statements
Raghu 27/10/2022 3225736869 Table Alignment Fixes and Enhancements
Ashraf 10/30/2022 3225736869 fixed table pagination issue
Prakash 10/31/2022 3225736869 Made Toolbar false.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
Dilip 11/03/2022  3225736869 added task code to delete popup
Prakash 11/16/2022 3225736869  added margin for buttons.
Prakash 11/16/2022 3225736869  added table data and edit and delete  .
akhila 11/18/2022 3225736869  integrated post api and get api .
Prakash 11/18/2022 3225736869  Fixed Table column Alignment.
akhila  11/18/2022 3225736869 fixed data prepopulation issue
akhila  11/19/2022 3225736869 fixed save api payload issues.
SaiKrishna 11/21/2022 2699217591 Revamped pre population and payload code
SaiKrishna 11/22/2022 2699217591 Add task issues and payload changes done

Guru Prasad  11/22/2022 3225736869 Changed icons in the table
Saikrishna 11/24/2022 2699217591 Added new columns and fixed minor bugs
Sai Maheshwar 12/04/2022 2699217591 renamed form field label
Dilip 12/05/2022  2699217591 Removed unecesarry console.log statements
Saikrishna 12/09/2022 2699217591 save and stay in page functionality added.
Ashraf 12/16/2022 2699217591 fixed role based access
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
Prakash 12/22/2022 3225736869 Button Alignments Responsiveness.
Saikrishna 12/23/2022 3225736869 added job code and job description
akhila 3225736869 fixed labels in jobcode and jobdescription
lalitha 12/28/2022 3225736869 fixed issue when click on save & next status showing completed in Add Task stepper
Raghu 12/29/2022 3225736869 Table Footer Styling Fixes.
Dilip 11/22/2022 3225736869 Add task parameter changes done
Dilip 01/02/2023 3225736869 Fixed payload issue for isDraft
kavyareddy 01/09/2023 3225736869 Fixed render issue of skip and completion
Lalitha 01/12/2023 3225736869 changed isDraft value to N
Akhila 02/01/2023 3225736869 bug fixed prepopulation issue and table issue fixed
Sohel 02/09/2023 3225736869 payload changes
suresh peddavoora 02/22/2023 3225736869 new UI changes
suresh peddavoora 02/22/2023 3225736869 New UI changes
Sohel 03/04/2023 3225736869 Added Letter Batches in Night Job
Ravi 05/31/2023 3225736869 changed delete popup message
Akhila 06/05/2023 3225736869 unsaved changes bug fixed/implemented
Akhila 06/22/2023 3225736869 conditionally disable save and finish button on submission
Sohel 06/22/2023 2692790263 Fixed Schedular Task Type Issue
Ravi 07/05/2023 2692790263 fixed prepopulate issue
*/

import React, {useState, useEffect, useRef} from 'react';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Button, Grid, TablePagination, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {tableIcons} from '../../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../../constants/ReusableTablePagination';
// import DeleteTableRecordPopup from './../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../../components/DialogBox';
import AddTaskForm from './AddTaskForm';
import {
  postAddNightJob,
  fetchJobDetails,
  ResetMessage as resetMessage,
} from '../../../../../../redux/reducers/NightJobs/AddNightJob';
import {useDispatch, useSelector} from 'react-redux';
// import { ResetMessage } from "../../../../../../redux/reducers/BRE/AddReportMaster";
import PageLoader from './../../../../../../components/PageLoader/index';
import {
  ErrorSnackbar,
  SuccessSnackbar,
} from './../../../../../../components/CustomSnackBar/index';
import _ from 'lodash';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BreadCrums from '../../../../../../util/BreadCrum';
import {getDropDownData as getLetterDropDownData} from '../../../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import moment from 'moment';
import {submissionStart} from '../../../../../../redux/reducers/CommonActions/commonActions';
import {getDropDownData} from '../../../../../../redux/reducers/BRE/AddRecordFormat';

export default function NightJobTaskTable({
  nightJobCode,
  deletedRules,
  setDeletedRules,
  //   setIsEditMode,
  // rowData,
  // setRowData,
  setOldRuleCode,
  handleBack,
  activeStep,
  handleNext,
  handleDirty,
  selected,
}) {
  const useStyles = makeStyles({
    letterTable: {
      '& .MuiTableRow-root': {
        color: 'inherit',
        display: 'inherit',
        outline: 0,
        verticalAlign: 'middle',
      },
      '& .MuiTableBody-root': {
        display: 'inherit',
        textAlign: 'center',
      },
      '& .MuiTableSortLabel-root > div': {
        fontSize: '0.790rem !important',
        fontWeight: 'bold !important',
      },
    },
  });

  const {roleData} = useSelector(({role}) => role);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const roleAccess = roleData?.window?.['Scheduler']?.SC;
  const {fieldCodeData} = useSelector(({addReportMaster}) => addReportMaster);
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const updatedReportData = (reportObject) => {
    const initialObj = {};
    const initialReportObject = Object.assign(initialObj, reportObject);
    initialReportObject.WorkQueueList = initialReportObject.showDashBoard;
    delete initialReportObject.showDashBoard;
    return initialReportObject;
  };
  const columns = [
    {
      title: 'S.No',
      render: (rowData) =>
        rowData.tableData.id ? rowData.tableData.id + 1 : rowData.tableData.id === 0 ? 1 : '',
    },
    {
      title: 'Task Code',
      field: 'taskCode',
      render: (rowData) => (rowData?.taskCode ? rowData?.taskCode : '-'),
    },
    {
      title: 'Task Type',
      field: 'taskType',
      render: (rowData) => (rowData?.taskType ? rowData?.taskType : '-'),
    },
    {
      title: 'Continue on task failure',
      field: 'continuePrevTaskFailure',
      render: (rowData) => (rowData?.continuePrevTaskFailure === 'Y' ? 'Yes' : 'No'),
    },
    {
      title: 'Skip on completion',
      field: 'skipOnCompletion',
      render: (rowData) => (rowData?.skipOnCompletion === 'Y' ? 'Yes' : 'No'),
    },
    {
      title: 'Parameter(s)',
      // field: "params",
      render: (rowData) => {
        const triggerObject = rowData?.taskTriggerGroupParameterRequest ?
          _.omit(rowData?.taskTriggerGroupParameterRequest, [
            '',
            'triggerGroupCode',
            'jobId',
            'taskId',
            'triggerGroupParameterId',
          ]) :
          {};
        const reportObject = rowData?.taskReportParameterRequest ?
          _.omit(updatedReportData(rowData?.taskReportParameterRequest), [
            'reportParameterId',
            'jobId',
            'reportId',
            // "reportCode",
            'taskId',
          ]) :
          {};
        const updatedRowData = _.omit(rowData, [
          'taskId',
          'jobCode',
          'seqNo',
          // "skipOnCompletion",
          // "continuePrevTaskFailure",
          'taskDataManagerParameterRequest',
          // "taskReportParameterRequest",
          // "taskTriggerGroupParameterRequest",
          'tableData',
          'description',
        ]);
        const accessMethodRequestData = (data) => {
          const initialObj = {};
          const accessMethodObj = Object.assign(initialObj, data);
          accessMethodObj.filterMethod = accessMethodObj.accessMethod;
          delete accessMethodObj.accessMethod;
          return {
            ...accessMethodObj,
            filterMethod: getObject(accessMethodObj?.filterMethod, fieldCodeData)?.description,
            startDate: accessMethodObj?.startDate ?
              moment(accessMethodObj?.startDate).format('MM/DD/YYYY') :
              '',
            endDate: accessMethodObj?.endDate ?
              moment(accessMethodObj?.endDate).format('MM/DD/YYYY') :
              '',
          };
        };

        const getTextValue = (key) => {
          if (key === 'Y') {
            return 'Yes';
          } else if (key === 'N') {
            return 'No';
          }
        };

        return (
          <div style={{whiteSpace: 'pre-wrap'}}>
            {JSON.stringify({
              ...updatedRowData,
              triggerCode: rowData?.taskTriggerGroupParameterRequest?.triggerGroupCode,
              ...triggerObject,
              ...reportObject,
              displayHeader: getTextValue(rowData?.taskReportParameterRequest?.displayHeader),
              generateWorkQueue: getTextValue(
                rowData?.taskReportParameterRequest?.generateWorkQueue,
              ),
              WorkQueueList: getTextValue(rowData?.taskReportParameterRequest?.showDashBoard),
              skipOnCompletion: getTextValue(rowData?.skipOnCompletion),
              continuePrevTaskFailure: getTextValue(rowData?.continuePrevTaskFailure),
              accessMethodRequest: rowData?.taskReportParameterRequest?.accessMethodRequest ?
                accessMethodRequestData(rowData?.taskReportParameterRequest?.accessMethodRequest) :
                rowData?.taskTriggerGroupParameterRequest?.accessMethodRequest &&
                  accessMethodRequestData(
                    rowData?.taskTriggerGroupParameterRequest?.accessMethodRequest,
                  ),
            })}
          </div>
        );
      },
    },
  ];
  const {
    isLoading,
    successMsg,
    errorMsg,
    addNightJob,
    jobDataId,
    jobDetailsData,
  } = useSelector(({addNightJob}) => addNightJob);
  const classes = useStyles();
  const [taskData, setTaskData] = useState([]);
  const [deletedTasks, setDeletedTasks] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editgetData, setEditGetData] = useState(false);
  const [rowEditData, setRowEditData] = useState();
  const [userData, setUserData] = useState({});
  const saveRef = useRef();

  const dispatch = useDispatch();
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setUserData(rowData);
    // setTaskData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
  };
  // const handleSubmit = () => {
  //   setLoader(true);
  //   new Promise((resolve) => {
  //     setTimeout(() => {
  //       const data = [...formData];
  //       const newData = data.filter((row) => row.taskCode !== userData.taskCode);
  //       setFormData(newData);
  //       userData?.ruleId && deletedRules.length > 0
  //         ? setDeletedRules([...deletedRules, userData.ruleId])
  //         : setDeletedRules([userData.ruleId]);
  //       resolve();
  //       handleCloseDialog();
  //       setLoader(false);
  //     }, 1000);
  //   });
  // };
  // const onDragEnd = (result) => {
  //   const { destination, source } = result;
  //   if (!destination) {
  //     return;
  //   }
  //   if (source.index !== destination.index) {
  //     let copyRows = [...formData];
  //     let temp = formData[source.index];
  //     copyRows.splice(source.index, 1);
  //     copyRows.splice(destination.index, 0, temp);
  //     setFormData(copyRows);
  //   }
  // };
  useEffect(() => {
    handleDirty(false, 'reset');
    dispatch(getDropDownData());
  }, []);

  useEffect(() => {
    if (addNightJob === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
        saveRef.current && dispatch(fetchJobDetails(jobDataId));
      }, 2000);
    }
  }, [addNightJob]);
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1000);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    if (jobDataId) {
      dispatch(fetchJobDetails(jobDataId));
    }
  }, [jobDataId]);
  useEffect(() => {
    dispatch(getLetterDropDownData());
  }, []);
  const handleSubmit = () => {
    dispatch(submissionStart());
    const passValues1 = {
      createdFor: jobDetailsData?.createdFor ? jobDetailsData?.createdFor : '',
      deleteTaskIds: deletedTasks,
      jobCode: jobDetailsData?.jobCode ? jobDetailsData?.jobCode : '',
      jobDescription: jobDetailsData?.jobDescription ? jobDetailsData?.jobDescription : '',
      jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
      jobName: jobDetailsData?.jobName ? jobDetailsData?.jobName : '',
      jobStatus: jobDetailsData?.jobStatus ? jobDetailsData?.jobStatus : '',
      lastRunTime: '',
      nextRunTime: '',
      noOfRetries: jobDetailsData?.noOfRetries ? jobDetailsData?.noOfRetries : 0,
      notifyCompletionEmails: jobDetailsData?.notifyCompletionEmails ?
        jobDetailsData?.notifyCompletionEmails :
        [],
      notifyErrorEmails: jobDetailsData?.notifyErrorEmails ? jobDetailsData?.notifyErrorEmails : [],
      priority: jobDetailsData?.priority ? jobDetailsData?.priority : 0,
      retryAfter: jobDetailsData?.retryAfter ? jobDetailsData?.retryAfter : 0,
      clientNumbers: jobDetailsData?.clientNumbers ? jobDetailsData?.clientNumbers : [],

      // isDraft: jobDetailsData?.taskRequest?.length > 0 ? "N" : "Y",
      isDraft: 'N',
      tabType: 'Schedule',
      taskRequest: taskData?.map((each) => {
        // let updatedObj = each
        // delete each?.tableData
        const updatedObj = _.omit(each, 'tableData');
        return {
          ...updatedObj,
        };
      }),
    };
    dispatch(postAddNightJob(passValues1));
  };
  const handleDeleteSubmit = () => {
    setDeletedTasks([...deletedTasks, userData?.taskId]);
    setTaskData(taskData?.filter((each) => each?.taskCode !== userData?.taskCode));
    setIsDelete(false);
    handleDirty(true);
  };
  useEffect(() => {
    if (jobDetailsData?.taskRequest?.length) {
      setTaskData(
        jobDetailsData?.taskRequest?.map((each, i) => ({
          ...each,
          tableData: {id: i},
        })),
      );
    } else {
      setTaskData([]);
    }
  }, [jobDetailsData]);
  return (
    <>
      {roleAccess?.edit && (
        <BreadCrums
          name={'Job Name'}
          code={jobDetailsData?.jobCode}
          description={'Job Description'}
          descriptionValue={jobDetailsData?.jobDescription}
        />
      )}
      <div className="table-header table-card-header new-standard-textfields">
        <Typography variant="h4">Tasks</Typography>
        <Button
          variant="outlined"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            setOpen(true);
            setRowEditData({});
          }}
        >
          <AddIcon />
          Add Task
        </Button>
      </div>

      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Scheduler"
        value={`Are you sure you want to delete the ${userData?.taskCode} Scheduler?`}
        handleSubmit={handleDeleteSubmit}
      />
      <Grid item xs={12}>
        <div
          className={`custom-table global-field-table custom-actions-icon new-standard-textfields`}
        >
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={taskData}
            textAlign="left"
            options={{
              search: false,
              toolbar: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                  handleEditRow(rowData);
                  setEditGetData(true);
                  setRowEditData(rowData);
                  // setOldRuleCode(rowData.taskCode);
                },
              },
              // {
              //   icon: "visibility",
              //   tooltip: "View Executions",
              //   disabled: !nightJobCode,
              // },
              {
                icon: () => <DeleteOutlineOutlinedIcon />,
                // disabled: !breCode && !disableDelete,
                tooltip: 'Delete',
                onClick: (event, rowData) => handleDelete(rowData),
              },
            ]}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3 new-standard-textfields">
          <Button
            variant="outlined"
            className={`reset-btn  ${classes.buttonRoot}`}
            disabled={activeStep === 0}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant="outlined"
            type="submit"
            className={`search-btn mx-2 ${classes.buttonRoot}`}
            disabled={
              !taskData?.length ||
              (!roleAccess?.edit && jobDetailsData?.taskRequest?.length && selected) ||
              enabledSubmission
            }
            onClick={() => {
              saveRef.current = true;
              handleDirty(false, 'fixed');
              handleSubmit();
            }}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              saveRef.current = false;
              handleSubmit();
              // handleNext();
            }}
            disabled={
              !taskData?.length ||
              (!roleAccess?.edit && jobDetailsData?.taskRequest?.length && selected) ||
              enabledSubmission
            }
            variant="outlined"
            type="submit"
            className={`search-btn ${classes.buttonRoot}`}
          >
            Save & Next
          </Button>
        </div>
        <DialogBox
          open={open || isEditMode}
          dialogClose={handleClose}
          hideFooter={true}
          maxWidth={'lg'}
          title={(isEditMode && 'Edit Task ') || (open && 'Add Task')}
        >
          <AddTaskForm
            setTaskData={setTaskData}
            taskData={taskData}
            handleClose={handleClose}
            rowData={rowData}
            setRowData={rowData}
            isEditMode={isEditMode}
            editgetData={editgetData}
            rowEditData={rowEditData}
          />
        </DialogBox>
      </Grid>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
}
